import { render, staticRenderFns } from "./AppSwitcher.vue?vue&type=template&id=22d0b78c&scoped=true&"
import script from "./AppSwitcher.vue?vue&type=script&lang=js&"
export * from "./AppSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./AppSwitcher.vue?vue&type=style&index=0&id=22d0b78c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0b78c",
  null
  
)

export default component.exports